import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Card, CardBody, CardFooter, CardHeader, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { useService } from "../../context/ServiceContext";
import ErrorAlertContent from "../ErrorAlertContent";
import { fireAlert, fireConfirm } from "../../utils/alerts";
import LoadedContent from "../LoadedContent";
import { MultiSelect } from "react-multi-select-component";
import CloneCertificateOptions from "../Modals/CloneCertificateOptions";
import CertificateProductSelection from "./CertificateProductSelection";
import ExpiryCertificateOptions from "../Modals/ExpiryCertificateOptions";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useSessionStorage } from "../../utils/useSessionStorage";
import { useUser } from "../../context/UserContext";
import roles from "../../identity/roles";

function CertificateTemplateSelection({ clone, onCertificateClone }) {
  const intl = useIntl();
  const {
    certificateLinkedSeriesProvider,
    certificateGenerateProvider,
    certificateSearchProvider,
    certificateListProvider,
    certificateCloneListProvider,
    certificateExpiryStore,
    certificateLanguagesProvider,
    certificateRemoval,
  } = useService();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingResults, setIsLoadingResults] = useState(true);
  const [languages, setLanguages] = useState([]);
  const [companies, setCompanies] = useState([]);
  //const [templates, setTemplates] = useState([]);
  const [existingSeries, setExistingSeries] = useState([]);
  const [additionalSeries, setAdditionalSeries] = useState([]);
  const { user } = useUser();

  // const [selectedCompany, setSelectedCompany] = useSessionStorage("Genesis.Certificates.SelectedCompany", -1);
  // const [selectedSeries, setSelectedSeries] = useSessionStorage("Genesis.Certificates.SelectedSeries", "");
  // const [selectedAdditionalSeries, setSelectedAdditionalSeries] = useSessionStorage("Genesis.Certificates.SelectedAdditionalSeries", []);
  // const [selectedTemplate, setSelectedTemplate] = useSessionStorage("Genesis.Certificates.SelectedTemplate", null);
  // const [selectedLanguage, setSelectedLanguage] = useSessionStorage("Genesis.Certificates.SelectedLanguage", "");
  // const [includeExpired, setIncludeExpired] = useSessionStorage("Genesis.Certificates.IncludeExpired", false);

  const [selectedCompany, setSelectedCompany] = useState(-1);
  const [selectedSeries, setSelectedSeries] = useState("");
  const [selectedAdditionalSeries, setSelectedAdditionalSeries] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [includeExpired, setIncludeExpired] = useState(false);

  const [submittedSearch, setSubmittedSearch] = useState(false);
  const [results, setResults] = useState([]);

  const [isValid, setIsValid] = useState(false);
  const [showCloneOptions, setShowCloneOptions] = useState(false);
  const [cloneData, setCloneData] = useState(null);

  const [showExpiryOptions, setShowExpiryOptions] = useState(false);
  const [expiryData, setExpiryData] = useState(null);

  const [refreshTrigger, setRefreshTrigger] = useState(true);

  const customValueRenderer = (selected, _options) => {
    return selected.map(({ label }) => label).join(",");
  };

  const localisedStrings = {
    allItemsAreSelected: "All items are selected.",
    clearSearch: "Clear Search",
    clearSelected: "Clear Selected",
    noOptions: "No options",
    search: "Search",
    selectAll: "Select All",
    selectAllFiltered: "Select All (Filtered)",
    selectSomeItems: intl.formatMessage({ id: "product_information.select_an_option", defaultMessage: "Please select an option" }),
  };

  useEffect(() => {
    setIsValid(
      selectedCompany !== null &&
        selectedCompany !== "" &&
        selectedSeries !== null &&
        selectedLanguage !== null &&
        selectedLanguage !== "" &&
        selectedTemplate !== null &&
        selectedTemplate !== "",
    );
  }, [selectedCompany, selectedSeries, selectedLanguage, selectedTemplate]);

  useEffect(() => {
    async function getData() {
      try {
        const languages = await certificateLanguagesProvider.get();
        setLanguages(languages ?? []);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }
    if (languages.length == 0) getData();
  }, []);

  useEffect(() => {
    async function getData() {
      try {
        const linkedSeries = await certificateLinkedSeriesProvider.store({
          keyCompany: selectedCompany,
          series: selectedSeries,
          language: selectedLanguage ?? 0,
        });

        setAdditionalSeries(
          linkedSeries.map((a) => {
            return {
              label: a.shortNameComercial,
              value: a.codSeriesComercial,
            };
          }) ?? [],
        );

        if (linkedSeries.length == 0) {
          setSelectedAdditionalSeries([]);
        }

        console.log(linkedSeries);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }
    getData();
  }, [selectedCompany, selectedSeries, selectedLanguage]);

  // useEffect(() => {
  //   async function getData() {
  //     try {
  //       const searchResults = await certificateSearchProvider.store({
  //         keyCompany: null,
  //         idTechnicalDocumentation: null,
  //         series: null,
  //       });
  //       setExistingSeries(searchResults?.series ?? []);
  //       setCompanies(searchResults?.companies ?? []);
  //     } catch (error) {
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  //   if (selectedCompany == -1 && selectedTemplate == null && selectedSeries == "") getData();
  // }, [selectedCompany, selectedTemplate, selectedSeries]);

  useEffect(() => {
    async function getData() {
      try {
        const searchResults = await certificateSearchProvider.get({
          keyCompany: selectedCompany,
        });
        setExistingSeries(searchResults?.series ?? []);
        if (selectedCompany == -1) setCompanies(searchResults?.companies ?? []);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }
    getData();
  }, [selectedCompany]);

  // useEffect(() => {
  //   async function getData() {
  //     try {
  //       const searchResults = await certificateSearchProvider.store({
  //         series: selectedSeries,
  //       });
  //       setCompanies(searchResults?.companies ?? []);
  //     } catch (error) {
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  //   getData();
  // }, [selectedSeries]);

  // useEffect(() => {
  //   async function getData() {
  //     try {
  //       const searchResults = await certificateSearchProvider.store({
  //         keyCompany: selectedCompany,
  //         series: selectedSeries,
  //       });
  //       setTemplates(searchResults?.templates ?? []);
  //     } catch (error) {
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  //   getData();
  // }, [selectedSeries, selectedCompany]);

  useEffect(() => {
    async function getData() {
      try {
        if (selectedSeries !== "" && selectedLanguage !== "") {
          setIsLoadingResults(true);
          setSubmittedSearch(true);
          var certificateProvider = clone ? certificateCloneListProvider : certificateListProvider;
          const results = await certificateProvider.get({
            keyCompany: selectedCompany,
            series: selectedSeries,
            language: selectedLanguage,
            includeInvalid: includeExpired,
          });
          setResults(results);
        }
      } catch (error) {
      } finally {
        setIsLoadingResults(false);
      }
    }
    getData();
  }, [selectedSeries, selectedCompany, selectedLanguage, refreshTrigger, includeExpired]);

  useEffect(() => {
    setData(results);
    setSortConfig({ key: null, direction: "asc" });
  }, [results]);

  const [data, setData] = useState([]);
  const [searchTermDocumentReference, setSearchTermDocumentReference] = useState("");
  const [searchTermTypeOfDocument, setSearchTermTypeOfDocument] = useState("");
  const [searchTermValidFrom, setSearchTermValidFrom] = useState("");
  const [searchTermValidTo, setSearchTermValidTo] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const isValidDateString = (str) => {
    return /^\d{4}-\d{2}-\d{2}$/.test(str) && !isNaN(new Date(str).getTime());
  };

  const sortData = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedData = [...data].sort((a, b) => {
      const valueA = a[key];
      const valueB = b[key];

      if (key == "validTo" || key == "validFrom") {
        const isValidA = isValidDateString(valueA);
        const isValidB = isValidDateString(valueB);

        if (isValidA && isValidB) {
          const dateA = new Date(valueA);
          const dateB = new Date(valueB);
          return direction === "asc" ? dateA - dateB : dateB - dateA;
        }
        if (!isValidA && !isValidB) return 0;
        if (!isValidA) return 1;
        if (!isValidB) return -1;
      }

      if (typeof valueA === "string" && typeof valueB === "string") {
        const strA = valueA.toLowerCase();
        const strB = valueB.toLowerCase();
        if (strA < strB) return direction === "asc" ? -1 : 1;
        if (strA > strB) return direction === "asc" ? 1 : -1;
        return 0;
      }

      if (valueA < valueB) return direction === "asc" ? -1 : 1;
      if (valueA > valueB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setData(sortedData);
    setSortConfig({ key, direction });
  };

  useEffect(() => {
    setData(results);
    setSortConfig({ key: null, direction: "asc" });
  }, [results]);

  const filteredData = data.filter((item) => {
    const matchesSearch = (value, searchTerm) => {
      if (!searchTerm || searchTerm.trim() === "") return true; // Show all when empty
      const stringValue = String(value || "").toLowerCase();
      return stringValue.includes(searchTerm.toLowerCase());
    };

    return (
      matchesSearch(item.documentReference, searchTermDocumentReference) &&
      matchesSearch(item.typeOfDocument, searchTermTypeOfDocument) &&
      matchesSearch(item.validFrom, searchTermValidFrom) &&
      matchesSearch(item.validTo, searchTermValidTo)
    );
  });

  const resetData = () => {
    // setData(initialData);
    // setSortConfig({ key: null, direction: 'asc' });
    // setSearchTerm('');
  };

  async function defineExpiry(data) {
    setIsLoading(true);
    try {
      await certificateExpiryStore.store(data);
      setRefreshTrigger(!refreshTrigger);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  async function removeCertificate(documentClass, idTechnicalDocumentation, language, idTipoDocumental) {
    fireConfirm(
      intl.formatMessage({ id: "certificates.confirm_removal", defaultMessage: "Are you sure you want to remove this certificate?" }),
      intl.formatMessage({ id: "certificates.remove_certificate", defaultMessage: "Remove certificate" }),
      "question",
      intl.formatMessage({ id: "app.yes", defaultMessage: "Yes" }),
      intl.formatMessage({ id: "app.no", defaultMessage: "No" }),
      () => {
        processRemoveCertificate(documentClass, idTechnicalDocumentation, language, idTipoDocumental);
      },
      () => {},
    );
  }

  async function processRemoveCertificate(documentClass, idTechnicalDocumentation, language, idTipoDocumental) {
    setIsLoading(true);

    try {
      await certificateRemoval.find({
        documentClass,
        idTechnicalDocumentation,
        idTipoDocumental,
        language,
      });

      setRefreshTrigger(!refreshTrigger);
    } catch (error) {
      fireAlert(<ErrorAlertContent message={error.response.data.title} traceId={error.traceId} />, intl.formatMessage({ id: "app.error", defaultMessage: "Error" }), "error");
    }
    setIsLoading(false);
  }

  async function generate(keyCompany, series, language, templateId, idTipoDocumental, pdfName) {
    setIsLoading(true);

    try {
      const pdfBytes = await certificateGenerateProvider.get({
        keyCompany: keyCompany,
        series: series,
        language: language,
        templateId: templateId,
        idTipoDocumental: idTipoDocumental,
        nameOfCertificate: pdfName,
      });

      const blob = new Blob([new Uint8Array(pdfBytes)], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      link.download = `${pdfName ?? "certificate"}.pdf`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
      // fireAlert(
      //   <ErrorAlertContent message={intl.formatMessage(error.localization)} traceId={error.traceId} />,
      //   intl.formatMessage({ id: "app.error", defaultMessage: "Error" }),
      //   "error"
      // );
    }
    setIsLoading(false);
  }

  function getLanguage(language) {
    switch (language) {
      case -1:
        return "-";
      case 0:
        return intl.formatMessage({ id: "spanish", defaultMessage: "Spanish" });
      case 1:
        return intl.formatMessage({ id: "english", defaultMessage: "English" });
      case 2:
        return intl.formatMessage({ id: "french", defaultMessage: "French" });
      case 4:
        return intl.formatMessage({ id: "italian", defaultMessage: "Italian" });
    }
  }

  function onOptionsSelected(options) {
    setShowCloneOptions(false);
    onCertificateClone({
      options,
      ...cloneData,
    });
  }

  function onExpiryOptionsSelected(expiry) {
    setShowExpiryOptions(false);
    defineExpiry({
      endDate: expiry,
      ...expiryData,
    });
  }

  return (
    <LoadedContent loading={isLoading} overlay={true}>
      <Card>
        <CardBody>
          <Row>
            <Col lg="6">
              <FormGroup row className="my-0">
                <Label sm={6}>
                  <FormattedMessage id="datos_placa.company" defaultMessage="Company" />
                </Label>
                <Col sm={6}>
                  <Input type="select" value={selectedCompany} onChange={(e) => setSelectedCompany(parseInt(e.target.value))}>
                    <option value="">{intl.formatMessage({ id: "product_information.select_an_option", defaultMessage: "Please select an option" })}</option>
                    {companies
                      .filter((a) => a.key !== -1)
                      .map((a) => (
                        <option key={a.key} value={a.key}>
                          {a.key == -1 ? "Global" : a.value}
                        </option>
                      ))}
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row className="my-0">
                <Label sm={6}>
                  <FormattedMessage id="app.series" defaultMessage="Series" />
                </Label>
                <Col sm={6}>
                  <Input
                    type="select"
                    value={selectedSeries}
                    onChange={(e) => {
                      setSelectedSeries(parseInt(e.target.value));
                      setSelectedAdditionalSeries([]);
                    }}
                  >
                    <option value="">{intl.formatMessage({ id: "product_information.select_an_option", defaultMessage: "Please select an option" })}</option>
                    {existingSeries.map((a) => (
                      <option key={a.key} value={a.key}>
                        {a.value}
                      </option>
                    ))}
                  </Input>
                </Col>
              </FormGroup>
              {additionalSeries?.length > 1 && additionalSeries.filter((s) => s.value != selectedSeries).length > 0 && (
                <FormGroup row className="my-0">
                  <Label sm={6}>
                    <FormattedMessage id="certificates.additional_series" defaultMessage="Additional series" />
                  </Label>
                  <Col sm={6}>
                    <MultiSelect
                      valueRenderer={customValueRenderer}
                      options={additionalSeries.filter((s) => s.value != selectedSeries)}
                      value={selectedAdditionalSeries}
                      hasSelectAll={false}
                      onChange={setSelectedAdditionalSeries}
                      labelledBy="Select"
                      overrideStrings={localisedStrings}
                    />
                  </Col>
                </FormGroup>
              )}
              <FormGroup row className="my-0">
                <Label sm={6}>
                  <FormattedMessage id="certificates.language" defaultMessage="Language" />
                </Label>
                <Col sm={6}>
                  <Input type="select" value={selectedLanguage} onChange={(e) => setSelectedLanguage(parseInt(e.target.value))}>
                    <option value="">{intl.formatMessage({ id: "product_information.select_an_option", defaultMessage: "Please select an option" })}</option>
                    {languages.map((l) => (
                      <option key={l.idIdioma} value={l.idIdioma}>
                        {l.idioma}
                      </option>
                    ))}
                  </Input>
                </Col>
              </FormGroup>
              <FormGroup row className="my-0">
                <Col sm={6}></Col>
                <Col sm={6} className="pt-2">
                  <input type="checkbox" id="include-expired" checked={includeExpired} onChange={(e) => setIncludeExpired(e.target.checked)} />{" "}
                  <Label for="include-expired">
                    <FormattedMessage id="certificates.includeExpiredDocuments" defaultMessage="Include expired documents" />
                  </Label>
                </Col>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col></Col>
          </Row>
        </CardBody>
      </Card>
      {submittedSearch && (
        <Card className="mt-2">
          <CardHeader>
            <FormattedMessage id="certificates.available_documents" defaultMessage="Available documents" />
          </CardHeader>
          <CardBody>
            <LoadedContent loading={isLoadingResults}>
              <Table>
                <thead className="thead-light">
                  <tr>
                    <th onClick={() => sortData("documentReference")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="certificates.document_reference" defaultMessage="Document Reference" />{" "}
                      {sortConfig.key === "documentReference" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                      <div style={{ marginTop: 5 }}>
                        <input
                          type="text"
                          className="form-control-sm form-control"
                          value={searchTermDocumentReference}
                          onChange={(e) => {
                            e.stopPropagation();
                            setSearchTermDocumentReference(e.target.value);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    </th>
                    <th onClick={() => sortData("typeOfDocument")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="certificates.type_of_document" defaultMessage="Type Of Document" />{" "}
                      {sortConfig.key === "typeOfDocument" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                      <div style={{ marginTop: 5 }}>
                        <input
                          type="text"
                          className="form-control-sm form-control"
                          value={searchTermTypeOfDocument}
                          onChange={(e) => {
                            e.stopPropagation();
                            setSearchTermTypeOfDocument(e.target.value);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    </th>
                    <th>
                      <FormattedMessage id="certificates.language" defaultMessage="Language" />
                      <div style={{ marginTop: 5 }}>
                        <input type="text" className="form-control-sm form-control" style={{ opacity: 0, cursor: "default" }} />
                      </div>
                    </th>
                    <th onClick={() => sortData("validFrom")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="certificates.valid_from" defaultMessage="Valid From" /> {sortConfig.key === "validFrom" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                      <div style={{ marginTop: 5 }}>
                        <input
                          type="text"
                          className="form-control-sm form-control"
                          value={searchTermValidFrom}
                          onChange={(e) => {
                            e.stopPropagation();
                            setSearchTermValidFrom(e.target.value);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    </th>
                    <th onClick={() => sortData("validTo")} style={{ cursor: "validTo" }}>
                      <FormattedMessage id="certificates.valid_to" defaultMessage="Valid To" /> {sortConfig.key === "validTo" && (sortConfig.direction === "asc" ? "↑" : "↓")}
                      <div style={{ marginTop: 5 }}>
                        <input
                          type="text"
                          className="form-control-sm form-control"
                          value={searchTermValidTo}
                          onChange={(e) => {
                            e.stopPropagation();
                            setSearchTermValidTo(e.target.value);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    </th>

                    <th>
                      <FormattedMessage id="certificates.notaCert" defaultMessage="NotaCERT" />
                      <div style={{ marginTop: 5 }}>
                        <input type="text" className="form-control-sm form-control" style={{ opacity: 0, cursor: "default" }} />
                      </div>
                    </th>

                    <th></th>
                    {!clone && <th></th>}
                    {!clone && <th></th>}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData?.map((k) => (
                    <tr key={k.key}>
                      <td className="align-middle">{k.documentReference}</td>
                      <td className="align-middle">{k.typeOfDocument}</td>
                      <td className="align-middle">{k.language}</td>
                      <td className="align-middle">{k.validFrom}</td>
                      <td className="align-middle">{k.validTo}</td>
                      <td className="align-middle">{k.notaCert}</td>
                      {!clone && (
                        <td style={{ width: "1%" }}>
                          {k.validTo == null && (k.idTipoDocumental == 13 || k.idTipoDocumental == 166 || k.idTipoDocumental == 167 || k.idTipoDocumental == 37) && (
                            <Button
                              className={`float-right`}
                              color="link"
                              size="sm"
                              onClick={() => {
                                setExpiryData({
                                  startDate: k.validFrom ?? null,
                                  idTechnicalDocumentation: k.idTechnicalDocumentation,
                                  documentReference: k.documentReference,
                                  language: selectedLanguage,
                                  documentClass: k.documentClass,
                                  nameOfDocument: k.nameOfDocument,
                                  idTipoDocumental: k.idTipoDocumental,
                                });
                                setShowExpiryOptions(true);
                              }}
                              title={intl.formatMessage({ id: "certificates.define_expiry", defaultMessage: "Define expiry" })}
                            >
                              <i className="fas fa-calendar fa-lg"></i>
                            </Button>
                          )}
                        </td>
                      )}
                      {!clone && (
                        <td style={{ width: "1%" }}>
                          {[13, 166].includes(k.idTipoDocumental) ? (
                            <Link
                              to={`/certificates/declaration/existing/${selectedCompany}/${selectedSeries}/${selectedLanguage}/${encodeURIComponent(k.documentClass)}/${encodeURIComponent(k.documentReference)}`}
                              className={`btn btn-link btn-sm float-right`}
                              title={intl.formatMessage({ id: "certificates.edit", defaultMessage: "Edit" })}
                            >
                              <i className="fas fa-pen fa-lg"></i>
                            </Link>
                          ) : (
                            <></>
                          )}
                          {[37, 191].includes(k.idTipoDocumental) && k.idNotaCert && user.role === roles.SystemAdministrator ? (
                            <Link
                              to={`/certificates/existing/${selectedCompany}/${selectedSeries}/${selectedLanguage}/${encodeURIComponent(k.documentClass)}/${encodeURIComponent(k.documentReference)}/${
                                k.idTipoDocumental
                              }/${k.idNotaCert}`}
                              className={`btn btn-link btn-sm float-right`}
                              title={intl.formatMessage({ id: "certificates.edit", defaultMessage: "Edit" })}
                            >
                              <i className="fas fa-pen fa-lg"></i>
                            </Link>
                          ) : (
                            <></>
                          )}
                        </td>
                      )}
                      {!clone && (
                        <td style={{ width: "1%" }}>
                          <Button
                            className={`float-right`}
                            color="link"
                            size="sm"
                            onClick={() => {
                              removeCertificate(k.documentClass, k.idTechnicalDocumentation, selectedLanguage, k.idTipoDocumental);
                            }}
                            title={intl.formatMessage({ id: "certificates.remove", defaultMessage: "Remove" })}
                          >
                            <i className="fas fa-trash fa-lg"></i>
                          </Button>
                        </td>
                      )}
                      {clone == true && (
                        <td style={{ width: "1%" }}>
                          <Button
                            className="btn-outline-primary btn-sm float-right"
                            onClick={() => {
                              var series = [selectedSeries];
                              if (selectedAdditionalSeries?.length > 0) {
                                series = series.concat(selectedAdditionalSeries.map((s) => s.value));
                              }
                              var shortNameComercials = existingSeries.filter((t) => series.includes(t.key)).map((t) => t.value);

                              setShowCloneOptions(true);
                              setCloneData({
                                company: selectedCompany,
                                series: series,
                                language: selectedLanguage,
                                idTechnicalDocumentation: k.idTechnicalDocumentation,
                                idTipoDocumental: k.idTipoDocumental,
                                nameOfDocument: k.nameOfDocument,
                                documentClass: k.documentClass,
                                documentReference: k.documentReference,
                                typeOfDocument: k.typeOfDocument,
                                shortNameComercial: shortNameComercials,
                                regs: k.regs,
                                uploadedCertificates: k.uploadedCertificates,
                                validFrom: k.validFrom,
                                validTo: k.validTo,
                              });
                            }}
                          >
                            <FormattedMessage id="certificates.clone" defaultMessage="Clone" />
                          </Button>
                        </td>
                      )}
                      <td style={{ width: "1%" }}>
                        <Button
                          className={`${clone == true ? "btn btn-outline-dark" : "btn-outline-primary"} btn-sm float-right`}
                          onClick={() => {
                            var series = [selectedSeries];
                            if (selectedAdditionalSeries?.length > 0) {
                              series = series.concat(selectedAdditionalSeries.map((s) => s.value));
                            }
                            generate(selectedCompany, series, selectedLanguage, k.idTechnicalDocumentation, k.idTipoDocumental, k.nameOfDocument || k.documentReference);
                          }}
                        >
                          <FormattedMessage id="certificates.download" defaultMessage="Download" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {results.length == 0 && (
                <h4 className="text-center">
                  <FormattedMessage id="certificates.no_documents_found" defaultMessage="No documents found" />
                </h4>
              )}
            </LoadedContent>
          </CardBody>
        </Card>
      )}

      <CloneCertificateOptions isOpen={showCloneOptions} onOptionsSelected={onOptionsSelected} toggle={() => setShowCloneOptions(!showCloneOptions)}></CloneCertificateOptions>
      <ExpiryCertificateOptions
        isOpen={showExpiryOptions}
        onOptionsSelected={onExpiryOptionsSelected}
        toggle={() => setShowExpiryOptions(!showExpiryOptions)}
      ></ExpiryCertificateOptions>
    </LoadedContent>
  );
}

export default CertificateTemplateSelection;
